import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dynamic-price-summary',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="price-summary" *ngIf="totalPrice > 0">
      <!-- Breakdown items -->
      <ng-container *ngIf="breakdown.length > 1">
        <div class="price-row breakdown-item" *ngFor="let item of breakdown">
          <span class="price-label">{{ item.label }}</span>
          <span class="price-value small">{{ formatPrice(item.amount) }}</span>
        </div>
        <div class="price-divider"></div>
      </ng-container>

      <div class="price-row total">
        <span class="price-label">Totale</span>
        <span class="price-value">{{ formatPrice(totalPrice) }}</span>
      </div>

      <ng-container *ngIf="accontoAmount > 0 && accontoAmount < totalPrice">
        <div class="price-row deposit">
          <span class="price-label">Da pagare ora (acconto)</span>
          <span class="price-value">{{ formatPrice(accontoAmount) }}</span>
        </div>
        <div class="price-row remaining">
          <span class="price-label">Restante da pagare in sede</span>
          <span class="price-value">{{ formatPrice(totalPrice - accontoAmount) }}</span>
        </div>
      </ng-container>
    </div>
  `,
  styles: [`
    .price-summary {
      background: color-mix(in srgb, var(--accent, #ffd65b) 8%, transparent);
      border: 1px solid color-mix(in srgb, var(--accent, #ffd65b) 30%, transparent);
      padding: 20px;
      margin: 20px 0;
    }
    .price-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0;
      .price-label { color: var(--text, #e0e0e0); font-size: 14px; }
      .price-value { color: var(--accent, #ffd65b); font-size: 18px; font-weight: 600; }
      .price-value.small { font-size: 15px; font-weight: 500; }
      &.breakdown-item {
        .price-label { color: var(--text-muted, #999); font-size: 13px; }
      }
      &.total {
        .price-value { font-size: 20px; }
      }
      &.deposit {
        border-top: 1px solid color-mix(in srgb, var(--accent, #ffd65b) 20%, transparent);
        margin-top: 5px;
        padding-top: 12px;
        .price-value { font-size: 20px; }
      }
      &.remaining {
        .price-label { color: var(--text-muted, #999); }
        .price-value { color: var(--text-muted, #999); font-size: 14px; font-weight: 400; }
      }
    }
    .price-divider {
      height: 1px;
      background: color-mix(in srgb, var(--accent, #ffd65b) 20%, transparent);
      margin: 4px 0;
    }
  `],
})
export class DynamicPriceSummaryComponent {
  @Input() totalPrice = 0;
  @Input() accontoAmount = 0;
  @Input() breakdown: { label: string; amount: number }[] = [];

  formatPrice(cents: number): string {
    return `\u20AC${(cents / 100).toFixed(2)}`;
  }
}
